/* ==========================================================================
   Cooperation Subpages Module (100% Dynamic Multi-Language Article Body)
   Full Scraped Articles Translated Across EN, CS, DE, ES, AR, PT
   ========================================================================== */

import { t, getLocale } from '../locales/i18n.js';
import { articleData } from '../locales/articleTranslations.js';
import { getSvgIcon } from '../components/Icons.js';

const coopHubTexts = {
  cs: {
    eyebrow: 'PARTNERSTVÍ A SPOLUPRÁCE',
    title: 'Spolupráce',
    desc: 'Zapojte se do našeho globálního ekosystému jako distributor, aktivní občan, systémový integrátor, investor nebo technologický či OEM partner.'
  },
  en: {
    eyebrow: 'PARTNERSHIP & COLLABORATION',
    title: 'Cooperation',
    desc: 'Join our global ecosystem as a distributor, active citizen, system integrator, investor, or technology & OEM partner.'
  },
  de: {
    eyebrow: 'PARTNERSCHAFT & KOOPERATION',
    title: 'Kooperation',
    desc: 'Werden Sie Teil unseres globalen Ökosystems als Distributor, aktiver Bürger, Systemintegrator, Investor oder Technologie- & OEM-Partner.'
  },
  es: {
    eyebrow: 'ASOCIACIÓN Y COLABORACIÓN',
    title: 'Cooperación',
    desc: 'Únase a nuestro ecosistema global como distribuidor, ciudadano activo, integrador de sistemas, inversor o socio tecnológico y OEM.'
  },
  pt: {
    eyebrow: 'PARCERIA E COLABORAÇÃO',
    title: 'Cooperação',
    desc: 'Junte-se ao nosso ecossistema global como distribuidor, cidadão ativo, integrador de sistemas, investidor ou parceiro tecnológico e OEM.'
  },
  ar: {
    eyebrow: 'الشراكة والتعاون',
    title: 'التعاون',
    desc: 'انضم إلى نظامنا البيئي العالمي كموزع أو مواطن نشط أو مكامل أنظمة أو مستثمر أو شريك تكنولوجي وOEM.'
  }
};

const investorPortalTranslations = {
  en: {
    breadcrumbHome: 'Home',
    breadcrumbCoop: 'Cooperation',
    heroBtn: '📈 Investment Portal (jalud.eu) ↗',
    boxEyebrow: 'Official Investor Portal',
    boxTitle: 'Looking for Comprehensive Investor Details & Metrics?',
    boxDesc: 'All detailed information, financial metrics, and strategic expansion materials for investors are available on our dedicated portal:',
    boxBtn: 'Visit Investor Portal →',
    sidebarBtn: '📈 Visit Investor Opportunity Portal (jalud.eu) →',
    mapBtn: '🗺️ View Global Distributors & Integrators Map →'
  },
  cs: {
    breadcrumbHome: 'Domů',
    breadcrumbCoop: 'Spolupráce',
    heroBtn: '📈 Investiční portál (jalud.eu) ↗',
    boxEyebrow: 'Oficiální portál pro investory',
    boxTitle: 'Hledáte podrobné informace a metriky pro investory?',
    boxDesc: 'Veškeré podrobné informace, finanční metriky a strategické expanzní materiály pro investory jsou k dispozici na našem dedikovaném portálu:',
    boxBtn: 'Přejít na portál pro investory →',
    sidebarBtn: '📈 Přejít na Portál investičních příležitostí (jalud.eu) →',
    mapBtn: '🗺️ Zobrazit globální mapu distributorů a integrátorů →'
  },
  de: {
    breadcrumbHome: 'Startseite',
    breadcrumbCoop: 'Kooperation',
    heroBtn: '📈 Investorenportal (jalud.eu) ↗',
    boxEyebrow: 'Offizielles Investorenportal',
    boxTitle: 'Suchen Sie umfassende Investorendaten & Kennzahlen?',
    boxDesc: 'Alle detaillierten Informationen, Finanzkennzahlen und strategischen Expansionsunterlagen für Investoren finden Sie auf unserem dedizierten Portal:',
    boxBtn: 'Investorenportal besuchen →',
    sidebarBtn: '📈 Investorenportal (jalud.eu) besuchen →',
    mapBtn: '🗺️ Globale Händler- & Integratorenkarte anzeigen →'
  },
  es: {
    breadcrumbHome: 'Inicio',
    breadcrumbCoop: 'Cooperación',
    heroBtn: '📈 Portal de Inversores (jalud.eu) ↗',
    boxEyebrow: 'Portal Oficial para Inversores',
    boxTitle: '¿Busca información detallada y métricas para inversores?',
    boxDesc: 'Toda la información detallada, métricas financieras y materiales de expansión estratégica están disponibles en nuestro portal dedicado:',
    boxBtn: 'Visitar Portal de Inversores →',
    sidebarBtn: '📈 Visitar Portal de Oportunidades de Inversión (jalud.eu) →',
    mapBtn: '🗺️ Ver mapa global de distribuidores e integradores →'
  },
  pt: {
    breadcrumbHome: 'Início',
    breadcrumbCoop: 'Cooperação',
    heroBtn: '📈 Portal do Investidor (jalud.eu) ↗',
    boxEyebrow: 'Portal Oficial do Investidor',
    boxTitle: 'Procurando informações detalhadas e métricas para investidores?',
    boxDesc: 'Todas as informações detalhadas, métricas financeiras e materiais de expansão estratégica para investidores estão disponíveis no nosso portal dedicado:',
    boxBtn: 'Visitar Portal do Investidor →',
    sidebarBtn: '📈 Visitar Portal de Investimentos (jalud.eu) →',
    mapBtn: '🗺️ Ver mapa global de distribuidores e integradores →'
  },
  ar: {
    breadcrumbHome: 'الرئيسية',
    breadcrumbCoop: 'التعاون',
    heroBtn: '📈 بوابة المستثمرين (jalud.eu) ↗',
    boxEyebrow: 'بوابة المستثمرين الرسمية',
    boxTitle: 'هل تبحث عن معلومات تفصيلية ومؤشرات مالية للمستثمرين؟',
    boxDesc: 'جميع المعلومات التفصيلية والمؤشرات المالية واستراتيجيات التوسع للمستثمرين متاحة عبر بوابتنا المخصصة:',
    boxBtn: 'زيارة بوابة المستثمرين ←',
    sidebarBtn: '📈 زيارة بوابة الفرص الاستثمارية (jalud.eu) ←',
    mapBtn: '🗺️ عرض خريطة الموزعين والمكاملين حول العالم ←'
  }
};

const images = {
  'distributor': '/images/distributorsky-program-sed.png',
  'citizen': '/images/aktivni-obcane-bezpecne-mesto-sed.png',
  'integrator': '/images/systemovy-integrator-sed.png',
  'investor': '/images/investicni-partnerstvi-sed.png',
  'partner': '/images/oem-technologicke-partnerstvi-sed.png'
};

export function renderCooperationPage(routeKey = 'cooperation', onNavigate) {
  const container = document.createElement('div');
  container.className = 'sed-page';

  let coopKey = null;
  if (routeKey.includes('distributor') && !routeKey.includes('map')) coopKey = 'distributor';
  else if (routeKey.includes('citizen')) coopKey = 'citizen';
  else if (routeKey.includes('integrator')) coopKey = 'integrator';
  else if (routeKey.includes('investor')) coopKey = 'investor';
  else if (routeKey.includes('partner')) coopKey = 'partner';

  const locale = getLocale() || 'en';
  const localeArticles = articleData[locale] || articleData['en'];
  const invUi = investorPortalTranslations[locale] || investorPortalTranslations.en;
  const hubTexts = coopHubTexts[locale] || coopHubTexts.en;

  // RENDER DEDICATED SUBPAGE WITH DYNAMIC LANGUAGE ARTICLE TEXT
  if (coopKey && localeArticles[coopKey]) {
    const art = localeArticles[coopKey];
    const coopName = t(`cooperationTypes.${coopKey}`);
    const imgUrl = images[coopKey] || images['distributor'];

    container.innerHTML = `
      <section class="sed-section" style="background: linear-gradient(165deg, var(--navy-dark) 0%, var(--blue-dark) 100%); color: #ffffff; padding: 4.5rem 0 3.5rem;">
        <div class="sed-container">
          <div style="display: flex; gap: 0.5rem; align-items: center; font-size: 0.85rem; color: #cbd5e1; margin-bottom: 1.5rem; flex-wrap: wrap;">
            <a href="#home" style="color: #ffffff; text-decoration: none;" data-route="home">${invUi.breadcrumbHome}</a> /
            <a href="#cooperation" style="color: #ffffff; text-decoration: none;" data-route="cooperation">${invUi.breadcrumbCoop}</a> /
            <span style="color: var(--blue-primary); font-weight: 700;">${art.title || coopName}</span>
          </div>

          <div class="sed-detail-hero-grid">
            <div>
              <div class="sed-eyebrow" style="background: rgba(255,255,255,0.1); color: var(--blue-primary); border-color: rgba(255,255,255,0.2);">${art.eyebrow}</div>
              <h1 class="sed-page-hero-title">
                ${art.title}
              </h1>
              <p style="font-size: 1.15rem; color: #e2e8f0; line-height: 1.65; margin-bottom: 2rem;">
                ${art.lead}
              </p>
              <div style="display: flex; gap: 0.85rem; flex-wrap: wrap; align-items: center; margin-top: 1.75rem;">
                <a href="#contact" class="sed-btn sed-btn-hero sed-btn-primary" style="display: inline-flex; align-items: center; justify-content: center; height: 48px; min-height: 48px; padding: 0 1.5rem; font-size: 0.95rem; font-weight: 700; border-radius: 10px; text-decoration: none;" data-route="contact">
                  ${t('common.applyContact')}
                </a>
                ${coopKey === 'investor' ? `
                  <a href="https://www.jalud.eu/investment-opportunity/" target="_blank" rel="noopener noreferrer" class="sed-btn sed-btn-hero" style="display: inline-flex; align-items: center; justify-content: center; height: 48px; min-height: 48px; padding: 0 1.5rem; font-size: 0.95rem; font-weight: 700; border-radius: 10px; background: rgba(255,255,255,0.12); color: #ffffff; border: 1.5px solid rgba(255,255,255,0.6); backdrop-filter: blur(8px); text-decoration: none; transition: background 0.2s;" onmouseover="this.style.background='rgba(255,255,255,0.22)'" onmouseout="this.style.background='rgba(255,255,255,0.12)'">
                    ${invUi.heroBtn}
                  </a>
                ` : ''}
                <a href="#cooperation" class="sed-btn sed-btn-hero" style="display: inline-flex; align-items: center; justify-content: center; height: 48px; min-height: 48px; padding: 0 1.5rem; font-size: 0.95rem; font-weight: 700; border-radius: 10px; background: transparent; color: #ffffff; border: 1.5px solid rgba(255,255,255,0.35); text-decoration: none; transition: background 0.2s;" onmouseover="this.style.background='rgba(255,255,255,0.1)'" onmouseout="this.style.background='transparent'" data-route="cooperation">
                  ${t('common.allTypes')}
                </a>
              </div>
            </div>

            <!-- Official Header Photo -->
            <div style="background: #ffffff; padding: 1rem; border-radius: 16px; box-shadow: 0 20px 50px rgba(0,0,0,0.3); text-align: center;">
              <img src="${imgUrl}" alt="${art.title}" style="width: 100%; max-height: 380px; object-fit: cover; border-radius: 10px;">
            </div>
          </div>
        </div>
      </section>

      <!-- Main Overview & Translated Body Content -->
      <section class="sed-section" style="background-color: #ffffff; padding: 4rem 0;">
        <div class="sed-container">
          <div class="sed-detail-main-grid">
            
            <!-- Left Column: Rich Technical & Commercial Article Details -->
            <div>
              <h2 style="font-size: 2rem; font-weight: 800; color: var(--navy-dark); margin-bottom: 1.25rem; line-height: 1.25;">${art.h2}</h2>
              <p style="font-size: 1.05rem; line-height: 1.75; color: var(--text-dark); margin-bottom: 1.5rem;">${art.p1}</p>
              <p style="font-size: 1.05rem; line-height: 1.75; color: var(--text-dark); margin-bottom: 2rem;">${art.p2}</p>

              <!-- Strategic Investor Opportunity Callout Box -->
              ${coopKey === 'investor' ? `
                <div style="background: linear-gradient(135deg, #0a192f 0%, #1e3a8a 100%); border-radius: 16px; padding: 2.5rem; color: #ffffff; margin-bottom: 2.5rem; box-shadow: 0 10px 30px rgba(10, 25, 47, 0.2);">
                  <div class="sed-eyebrow" style="background: rgba(255,255,255,0.15); color: #38bdf8; border-color: rgba(255,255,255,0.3);">${invUi.boxEyebrow}</div>
                  <h3 style="font-size: 1.6rem; font-weight: 800; margin: 0.5rem 0 1rem; color: #ffffff;">${invUi.boxTitle}</h3>
                  <p style="font-size: 1.05rem; line-height: 1.65; color: #e2e8f0; margin-bottom: 1.5rem;">${invUi.boxDesc}</p>
                  <div style="display: flex; gap: 1rem; flex-wrap: wrap;">
                    <a href="https://www.jalud.eu/investment-opportunity/" target="_blank" rel="noopener noreferrer" class="sed-btn sed-btn-primary" style="font-weight: 800; padding: 0.85rem 1.75rem;">${invUi.boxBtn}</a>
                  </div>
                </div>
              ` : ''}

              <h3 style="font-size: 1.45rem; font-weight: 800; color: var(--navy-dark); margin: 2rem 0 1.25rem;">${art.h3}</h3>
              <div class="sed-grid-2" style="gap: 1.25rem; margin-bottom: 2.5rem;">
                <div style="background: #f8fafc; padding: 1.25rem; border-radius: 12px; border: 1px solid var(--slate-line);">
                  <strong style="color: var(--navy-dark); display: block; margin-bottom: 0.35rem; font-size: 1rem;">${art.b1_title}</strong>
                  <span style="font-size: 0.92rem; color: var(--text-muted); line-height: 1.55;">${art.b1_desc}</span>
                </div>
                <div style="background: #f8fafc; padding: 1.25rem; border-radius: 12px; border: 1px solid var(--slate-line);">
                  <strong style="color: var(--navy-dark); display: block; margin-bottom: 0.35rem; font-size: 1rem;">${art.b2_title}</strong>
                  <span style="font-size: 0.92rem; color: var(--text-muted); line-height: 1.55;">${art.b2_desc}</span>
                </div>
                <div style="background: #f8fafc; padding: 1.25rem; border-radius: 12px; border: 1px solid var(--slate-line);">
                  <strong style="color: var(--navy-dark); display: block; margin-bottom: 0.35rem; font-size: 1rem;">${art.b3_title}</strong>
                  <span style="font-size: 0.92rem; color: var(--text-muted); line-height: 1.55;">${art.b3_desc}</span>
                </div>
                ${art.b4_title ? `
                  <div style="background: #f8fafc; padding: 1.25rem; border-radius: 12px; border: 1px solid var(--slate-line);">
                    <strong style="color: var(--navy-dark); display: block; margin-bottom: 0.35rem; font-size: 1rem;">${art.b4_title}</strong>
                    <span style="font-size: 0.92rem; color: var(--text-muted); line-height: 1.55;">${art.b4_desc}</span>
                  </div>
                ` : ''}
              </div>
            </div>

            <!-- Right Column: Key Takeaways & Action -->
            <div>
              <div class="sed-sidebar-card" style="position: sticky; top: 100px;">
                <h4 style="font-size: 1.15rem; font-weight: 800; color: var(--navy-dark); margin-bottom: 1.25rem;">${t('common.coreBenefits')}</h4>
                <ul style="list-style: none; padding: 0; margin: 0 0 1.75rem 0; display: flex; flex-direction: column; gap: 0.85rem;">
                  ${art.benefits.map(b => `
                    <li style="display: flex; align-items: flex-start; gap: 0.65rem; font-size: 0.92rem; line-height: 1.5; color: var(--text-dark);">
                      <span style="color: var(--blue-primary); font-weight: 800; line-height: 1;">✓</span>
                      <span>${b}</span>
                    </li>
                  `).join('')}
                </ul>
                <a href="#contact" class="sed-btn sed-btn-primary" style="width: 100%; text-align: center;" data-route="contact">${t('common.applyContact')}</a>
                ${(coopKey === 'distributor' || coopKey === 'integrator') ? `
                  <a href="#distributors-map" class="sed-btn sed-btn-outline" style="width: 100%; text-align: center; margin-top: 0.75rem; color: var(--blue-primary); border-color: var(--blue-primary);" data-route="distributors-map">${invUi.mapBtn}</a>
                ` : ''}
              </div>
            </div>
          </div>
        </div>
      </section>
    `;

    container.querySelectorAll('[data-route]').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        if (onNavigate) onNavigate(link.getAttribute('data-route'));
      });
    });

    return container;
  }

  // 6 HUB CARDS MATCHING DETEKCE CARD STYLE (White bg, 1.5px border, 4px colored top accent, tinted 48x48 icon square, uniform height, bottom btn)
  const hubCards = [
    {
      key: 'map',
      route: 'distributors-map',
      title: t('header.distributorsMap') || (locale === 'cs' ? 'Mapa distributorů a systémových integrátorů' : 'Distributors & Integrators Map'),
      desc: locale === 'cs' 
        ? 'Interaktivní globální mapa certifikovaných distributorů a systémových integrátorů technologie Sound Event Detector.'
        : 'Interactive global network map of certified distributors and system integrators deploying Sound Event Detector.',
      iconKey: 'coopMap',
      color: 'var(--blue-primary)',
      accent: 'var(--blue-primary)'
    },
    {
      key: 'citizen',
      route: 'cooperation-citizen',
      title: localeArticles['citizen'] ? localeArticles['citizen'].title : (locale === 'cs' ? 'Občanská spolupráce pro bezpečnější města' : 'Active Citizens & Cities'),
      desc: localeArticles['citizen'] ? localeArticles['citizen'].lead : 'Iniciativa pro občany a samosprávy za bezpečnější města.',
      iconKey: 'coopCitizen',
      color: '#0284c7',
      accent: '#0284c7'
    },
    {
      key: 'distributor',
      route: 'cooperation-distributor',
      title: localeArticles['distributor'] ? localeArticles['distributor'].title : (locale === 'cs' ? 'Distributorský program' : 'Distributor Program'),
      desc: localeArticles['distributor'] ? localeArticles['distributor'].lead : 'Autorizovaný prodej, hardware NFR balíčky a maržová ochrana projektů.',
      iconKey: 'coopDistributor',
      color: 'var(--blue-primary)',
      accent: 'var(--blue-primary)'
    },
    {
      key: 'integrator',
      route: 'cooperation-integrator',
      title: localeArticles['integrator'] ? localeArticles['integrator'].title : (locale === 'cs' ? 'Integrace SED do bezpečnostních systémů' : 'System Integrator'),
      desc: localeArticles['integrator'] ? localeArticles['integrator'].lead : (locale === 'cs' ? 'Nativní software pro Hanwha, Axis, Hikvision a integrace do předních VMS (Genetec, Milestone, Avigilon, Geutebrück...).' : 'Native software for Hanwha, Axis, Hikvision and integration into leading VMS platforms (Genetec, Milestone, Avigilon, Geutebrück...).'),
      iconKey: 'coopIntegrator',
      color: '#10b981',
      accent: '#10b981'
    },
    {
      key: 'investor',
      route: 'cooperation-investor',
      title: localeArticles['investor'] ? localeArticles['investor'].title : (locale === 'cs' ? 'Investiční partnerství' : 'Investment Partnership'),
      desc: localeArticles['investor'] ? localeArticles['investor'].lead : 'Škálování Deep-Tech AI technologií na globálních bezpečnostních trzích.',
      iconKey: 'coopInvestor',
      color: '#f59e0b',
      accent: '#f59e0b'
    },
    {
      key: 'partner',
      route: 'cooperation-partner',
      title: localeArticles['partner'] ? localeArticles['partner'].title : (locale === 'cs' ? 'Technologické a OEM partnerství' : 'Technology & OEM Partnership'),
      desc: localeArticles['partner'] ? localeArticles['partner'].lead : 'Licencování edge algoritmů a embedded vývoj pro výrobce kamer.',
      iconKey: 'coopPartner',
      color: '#8b5cf6',
      accent: '#8b5cf6'
    }
  ];

  container.innerHTML = `
    <section class="sed-section" style="background: linear-gradient(165deg, var(--blue-light) 0%, #ffffff 70%); padding: 4.5rem 0 3rem;">
      <div class="sed-container">
        <div class="sed-section-header" style="max-width: 820px;">
          <div class="sed-eyebrow">${hubTexts.eyebrow}</div>
          <h1 class="sed-page-hero-title">${hubTexts.title}</h1>
          <p class="sed-section-desc">${hubTexts.desc}</p>
        </div>
      </div>
    </section>

    <section class="sed-section" style="background-color: #ffffff; padding-bottom: 5rem;">
      <div class="sed-container">
        <div class="sed-grid-3" style="gap: 1.75rem;">
          ${hubCards.map(card => `
            <div class="sed-card" style="display: flex; flex-direction: column; justify-content: space-between; min-height: 320px; background: #ffffff; border: 1.5px solid var(--slate-line); border-top: 4px solid ${card.accent}; border-radius: 14px; padding: 2rem; box-shadow: 0 4px 15px rgba(0,0,0,0.03); transition: transform 0.2s, box-shadow 0.2s;" onmouseover="this.style.transform='translateY(-4px)'; this.style.boxShadow='0 12px 28px rgba(0,0,0,0.08)';" onmouseout="this.style.transform='none'; this.style.boxShadow='0 4px 15px rgba(0,0,0,0.03)';">
              <div>
                <div style="width: 48px; height: 48px; border-radius: 12px; background: var(--blue-ultra-light); border: 1px solid var(--blue-light); display: flex; align-items: center; justify-content: center; margin-bottom: 1.25rem;">
                  ${getSvgIcon(card.iconKey, 24, card.color)}
                </div>
                <h3 class="sed-card-title" style="font-size: 1.25rem; font-weight: 800; color: var(--navy-dark); margin-bottom: 0.75rem; line-height: 1.35;">${card.title}</h3>
                <p class="sed-card-text" style="font-size: 0.92rem; line-height: 1.6; color: var(--text-dark); margin: 0; display: -webkit-box; -webkit-line-clamp: 4; -webkit-box-orient: vertical; overflow: hidden;">${card.desc}</p>
              </div>
              <div style="margin-top: 1.75rem;">
                <a href="#${card.route}" class="sed-btn sed-btn-primary" style="width: 100%; text-align: center; font-size: 0.88rem; font-weight: 700;" data-route="${card.route}">${t('common.learnMore')}</a>
              </div>
            </div>
          `).join('')}
        </div>
      </div>
    </section>
  `;

  container.querySelectorAll('[data-route]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      if (onNavigate) onNavigate(link.getAttribute('data-route'));
    });
  });

  return container;
}
